import React from 'react';
import { Mail, Linkedin, MapPin, Terminal } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-slate-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="border-t border-slate-200 pt-8">
          <div className="flex flex-col space-y-6 md:space-y-0 md:flex-row md:justify-between md:items-center">
            {/* Contact Links */}
            <div className="flex flex-wrap gap-6 items-center">
              <a href="mailto:ivyxie.work@gmail.com" 
                className="flex items-center space-x-2 text-slate-600 hover:text-sky-600 transition-colors">
                <Mail size={16} className="text-sky-600" />
                <span>ivyxie.work@gmail.com</span>
              </a>
              
              <div className="flex items-center space-x-2 text-slate-600">
                <MapPin size={16} className="text-sky-600" />
                <span>Sydney, Australia</span>
              </div>
              
              <a href="https://linkedin.com/in/yuwei-xie" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center space-x-2 text-slate-600 hover:text-sky-600 transition-colors">
                <Linkedin size={16} className="text-sky-600" />
                <span>linkedin.com/in/yuwei-xie</span>
              </a>
            </div>

            {/* Copyright */}
            <div className="flex items-center space-x-2 text-slate-500 text-sm">
              <Terminal size={16} className="text-sky-600" />
              <span>© {currentYear} Yuwei Xie. All rights reserved</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;